
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d00"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d00"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4Ts6F", function(module, exports) {

$parcel$export(module.exports, "register", () => $390219d48f3723f4$export$6503ec6e8aabbaf, (v) => $390219d48f3723f4$export$6503ec6e8aabbaf = v);
var $390219d48f3723f4$export$6503ec6e8aabbaf;
var $390219d48f3723f4$export$f7ad0328861e2f03;
"use strict";
var $390219d48f3723f4$var$mapping = new Map();
function $390219d48f3723f4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$390219d48f3723f4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $390219d48f3723f4$var$resolve(id) {
    var resolved = $390219d48f3723f4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$390219d48f3723f4$export$6503ec6e8aabbaf = $390219d48f3723f4$var$register;
$390219d48f3723f4$export$f7ad0328861e2f03 = $390219d48f3723f4$var$resolve;

});

var $9ba0c566be7cf33d$exports = {};

(parcelRequire("4Ts6F")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.81f231b7.js","iCgtN","light_mode_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.58c30a3c.svg","5pZbJ","dark_mode_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.85a07ca0.svg"]'));

var $507b85fca3e28539$exports = {};
$507b85fca3e28539$exports = new URL("light_mode_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.58c30a3c.svg", import.meta.url).toString();


var $5755db4b97fba064$exports = {};
$5755db4b97fba064$exports = new URL("dark_mode_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.85a07ca0.svg", import.meta.url).toString();


let $35da740d59af89ba$var$count = 0;
const $35da740d59af89ba$var$value = document.getElementById("count");
const $35da740d59af89ba$var$buttons = document.querySelectorAll(".btn");
const $35da740d59af89ba$var$square = document.getElementById("square");
const $35da740d59af89ba$var$squareRoot = document.getElementById("squareRoot");
const $35da740d59af89ba$var$container = document.querySelector(".container");
$35da740d59af89ba$var$buttons.forEach(function(item) {
    item.addEventListener("click", function(e) {
        const styles = e.currentTarget.classList;
        if (styles.contains("decrease")) $35da740d59af89ba$var$count--;
        else if (styles.contains("increase")) $35da740d59af89ba$var$count++;
        else $35da740d59af89ba$var$count = 0;
        const sq = Math.pow($35da740d59af89ba$var$count, 2);
        const root = Math.sqrt($35da740d59af89ba$var$count);
        $35da740d59af89ba$var$square.textContent = sq;
        $35da740d59af89ba$var$squareRoot.textContent = root;
        if ($35da740d59af89ba$var$count < 0) {
            $35da740d59af89ba$var$value.style.color = "#EB5C68";
            $35da740d59af89ba$var$squareRoot.style.display = "none";
            document.getElementById("error").style.display = "block";
        } else if ($35da740d59af89ba$var$count > 0) {
            $35da740d59af89ba$var$value.style.color = "#1D7486";
            $35da740d59af89ba$var$squareRoot.style.display = "block";
            document.getElementById("error").style.display = "none";
        } else {
            if ($35da740d59af89ba$var$container.classList.contains("body-dark")) $35da740d59af89ba$var$value.style.color = "white";
            else $35da740d59af89ba$var$value.style.color = "currentColor";
            document.getElementById("error").style.display = "none";
        }
        $35da740d59af89ba$var$value.textContent = $35da740d59af89ba$var$count;
    });
});
// Toggle between light and dark theme
const $35da740d59af89ba$var$themeToggle = document.querySelector(".toggle-theme");
const $35da740d59af89ba$var$themeToggleIcon = document.querySelector(".toggle-theme__icon");
let $35da740d59af89ba$var$lightThemeEnabled = true;
$35da740d59af89ba$var$themeToggle.addEventListener("click", ()=>{
    document.body.classList.toggle("body-dark");
    if ($35da740d59af89ba$var$lightThemeEnabled) {
        $35da740d59af89ba$var$themeToggleIcon.setAttribute("src", (0, (/*@__PURE__*/$parcel$interopDefault($507b85fca3e28539$exports))));
        $35da740d59af89ba$var$lightThemeEnabled = false;
    } else {
        $35da740d59af89ba$var$themeToggleIcon.setAttribute("src", (0, (/*@__PURE__*/$parcel$interopDefault($5755db4b97fba064$exports))));
        $35da740d59af89ba$var$lightThemeEnabled = true;
    }
});


//# sourceMappingURL=index.81f231b7.js.map
